import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import classNames from 'classnames';

const illustrations = {
  critical:
    'https://www.paypalobjects.com/paypal-ui/illustrations/svg/critical.svg',
  'more-info':
    'https://www.paypalobjects.com/paypal-ui/illustrations/svg/more-info.svg',
  'credit-cards':
    'https://www.paypalobjects.com/paypal-ui/illustrations/svg/credit-cards.svg',
  success:
    'https://www.paypalobjects.com/paypal-ui/illustrations/svg/success.svg',
  warning:
    'https://www.paypalobjects.com/paypal-ui/illustrations/svg/warning.svg',
  activity:
    'https://www.paypalobjects.com/paypal-ui/illustrations/svg/activity.svg',
};

const STYLES = StyleSheet.create({
  large: {
    width: 96,
  },
  small: {
    width: 72,
  },
});

export default function Illustration({
  type,
  size = 'large',
  className,
  ...rest
}) {
  const classes = classNames(className, {
    [css(STYLES.large)]: size === 'large',
    [css(STYLES.small)]: size === 'small',
  });

  return <img src={illustrations[type]} className={classes} {...rest} />;
}

Illustration.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
};
